import { http } from "./client";
import type { PageParams } from "@/types/api";
import type { AppNotification } from "@/types/domain";

export interface NotificationFilters extends PageParams {
  unread_only?: boolean;
}

export const notificationsApi = {
  list: (filters: NotificationFilters = {}) => http.getPage<AppNotification>("/notifications", filters),
  unreadCount: () => http.get<{ count: number }>("/notifications/unread-count"),
  markRead: (id: string) => http.patch<void>(`/notifications/${id}/read`, {}),
  markAllRead: () => http.patch<void>("/notifications/read-all", {}),
};
